exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".archive {\n  padding-bottom: 15px;\n  padding-top: 15px;\n  padding-bottom: 2.5vw;\n  padding-top: 2.5vw;\n}\n.archive ul .metadata {\n  margin-top: -0.7vh;\n  margin-bottom: 0.2vh;\n}\n.archive ul .metadata .timestamp {\n  padding: 0;\n  font-style: italic;\n  color: rgba(96,125,139,0.5);\n  border: none;\n  background: none;\n}\n.archive ul .metadata .timestamp .timePart {\n  display: inline;\n}\n", ""]);

// exports
